/**
 * 侧边栏：帮助中心
 * @author fulh
 * @update 2015-01-21 20:31:16
 */
$.module('MM.fixedbar.qq', function () {
  var MAIN = null,
    TMPL = MM.fixedbar.tmpl,
    ACTIONS = {
      notice: 'public/notice/1?page=1&size=5',
    };

  function _show() {
    MAIN = MM.fixedbar.main;
    MAIN.initDialog(
      $.template(TMPL.qq, MM.user.getUserInfo()),
      false,
      'qq',
      true,
    );
    _renderList();
  }

  function _renderList() {
    // $.getScript("https://wpa.b.qq.com/cgi/wpa.php", function() {
    //     console.log(BizQQWPA,23232)
    //     //MAIN.showDialog("qq");
    //     MM.core.debug("QQ:", BizQQWPA);
    //     BizQQWPA.addCustom([{
    //         aty: 0,
    //         nameAccount: '800072339',
    //         selector: 'j_qq_kefu'
    //     }, {
    //         aty: 0,
    //         nameAccount: '800021204',
    //         selector: 'j_qq_zhaomu'
    //     }, {
    //         aty: '1',
    //         a: '1006',
    //         nameAccount: '800021204',
    //         selector: 'j_qq_shipin'
    //     }]);
    // });

    $('#j_qq_kefu').click(MM.user.kefu.showKefu);

    //MM.ui.base.autoRender({
    //    selector: $("#j_fixedbar_help"),
    //    url: ACTIONS.notice,
    //    template: TMPL.fixedbar_help,
    //    successCallback: function() {}
    //});
  }

  return {
    show: _show,
  };
});
